import i18n from '../../../i18n'
export const ENGLISH_ALERTS_MODAL_TEXT = ` 

Our system is designed to help you by flagging potential risk words in student responses. However, please keep in mind:

- **Not every flagged message is a real risk.** The AI might highlight words that are not concerning in context.  
- **Not every real risk will be flagged.** While the AI is built to assist, it may not catch everything.  
- **This tool supports you – it does not replace your judgment.** Your care and attention to student wellbeing remain essential.  

This system is here to **complement** your efforts, not replace them. Please use it as an additional layer of support, but continue to engage with students as you normally would.  

**Legal Notice:** Upstrive is not responsible for the accuracy or effectiveness of AI-powered risk alerts. We do not assume liability for any risks that the system does or does not identify. The tool is designed to assist, but final responsibility for student wellbeing remains with the user.

By clicking **"I Understand"**, you acknowledge these points and agree to use the tool as intended.
`
export const GERMAN_ALERTS_MODAL_TEXT = ` 

Unser System wurde entwickelt, um dir zu helfen, indem es potenzielle Risikowörter in den Antworten der Schüler:innen markiert. Bitte beachte jedoch:
 
- **Nicht jede markierte Nachricht ist ein tatsächliches Risiko.** Die KI könnte Wörter hervorheben, die im Kontext nicht bedenklich sind.
- **Nicht jedes tatsächliche Risiko wird markiert.** Obwohl die KI zur Unterstützung entwickelt wurde, kann sie nicht alles erfassen.  
- **Dieses Tool unterstützt dich – es ersetzt nicht dein Urteilsvermögen.** Deine Fürsorge und Aufmerksamkeit für das Wellbeing der Schüler:innen bleiben unerlässlich.  

Dieses System soll deine Bemühungen ergänzen, nicht **ersetzen.** Bitte nutze es als zusätzliche Unterstützungsebene, aber interagiere weiterhin wie gewohnt mit den Schüler:innen.

**Rechtlicher Hinweis:** Upstrive übernimmt keine Verantwortung für die Genauigkeit oder Wirksamkeit der KI-gestützten Risiko-Warnungen. Wir übernehmen keine Haftung für Risiken, die das System erkennt oder nicht erkennt. Das Tool ist zur Unterstützung gedacht, aber die endgültige Verantwortung für das Wellbeing der Schüler:innen liegt beim Nutzer.

Durch Klicken auf **„Ich verstehe“** bestätigst du diese Punkte und stimmst zu, das Tool wie vorgesehen zu nutzen.

`
export const assignmentFilterList = ['displayAll', 'assignedToOther', 'assignedToMe', 'unassigned']
export const assignmentListMap = {
    displayAll: i18n.t('Display all'),
    assignedToOther: i18n.t('Assigned to others'),
    assignedToMe: i18n.t('Assigned to me'),
    unassigned: i18n.t('Not assigned'),
}
export const alertsFilterList = ['all', 'keywordsDetected', 'multipleNegativeEmotions']
export const alertsListMap = {
    all: i18n.t('All alerts'),
    keywordsDetected: i18n.t('Keyword alerts'),
    multipleNegativeEmotions: i18n.t('Uncomfortable emotions'),
}
export const counsellorFilterList = ['allClasses', 'option1', 'option2']
export const counsellorListMap = {
    allClasses: i18n.t('All classes'),
    option1: i18n.t('Option 1'),
    option2: i18n.t('Option 2'),
}
export const wellbeingComparisonList = ['all', 'comfortable', 'uncomfortable']
export const wellbeingComparisonListMap = {
    all: i18n.t('All emotions'),
    comfortable: i18n.t('Comfortable emotions'),
    uncomfortable: i18n.t('Uncomfortable emotions'),
}
export const emotionalWellbeingFactorsForSelectedStudentsList = {
    uncomfortable: {
        reasons: [
            {
                reason: 'social media',
                count: 6,
            },
            {
                reason: 'family',
                count: 5,
            },
            {
                reason: 'friends',
                count: 5,
            },
            {
                reason: 'health',
                count: 4,
            },
            {
                reason: 'achievement',
                count: 4,
            },
            {
                reason: 'sleep',
                count: 4,
            },
            {
                reason: 'wellbeing',
                count: 3,
            },
            {
                reason: 'school',
                count: 3,
            },
            {
                reason: 'myself',
                count: 2,
            },
        ],
        total: 36,
        total_emotions: 36,
    },
    comfortable: {
        reasons: [
            {
                reason: 'wellbeing',
                count: 12,
            },
            {
                reason: 'achievement',
                count: 11,
            },
            {
                reason: 'friends',
                count: 11,
            },
            {
                reason: 'sleep',
                count: 10,
            },
            {
                reason: 'family',
                count: 10,
            },
            {
                reason: 'myself',
                count: 9,
            },
            {
                reason: 'school',
                count: 7,
            },
            {
                reason: 'health',
                count: 7,
            },
            {
                reason: 'social media',
                count: 7,
            },
        ],
        total: 84,
        total_emotions: 84,
    },
}

export const engagementFactorsForSelectedList = {
    allContent: {
        _id: null,
        total: 21,
        avg_response: 0.6465773809523809,
    },
}
export const engagementFilterList = ['all', 'polls', 'questions', 'surveys']
export const engagementFilterMap = {
    all: i18n.t('All Activities'),
    polls: i18n.t('Polls'),
    questions: i18n.t('Questions'),
    surveys: i18n.t('surveys'),
}
export const alertsSortList = ['byNuberOfAlerts', 'assigned', 'unasigned']
export const alertsSortListMap = {
    byNuberOfAlerts: i18n.t('By number of alerts'),
    assigned: i18n.t('By number of assigned'),
    unasigned: i18n.t('By number of unassigned'),
}
